import React from 'react';

interface IProps {
  style?: any;
}

const SelectDescribeIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="none" viewBox="0 0 23 23">
      <path fill={props.style?.fillColor ? props.style.fillColor : "#204078"} d="M18.282 6.334L23 1.61 21.392 0l-4.745 4.697H6.3v-4H3.994v4H0v2.308h3.994v10.842c0 .644.51 1.154 1.153 1.154h10.83V23h2.305v-3.999h3.994v-2.308h-3.994V6.333zm-3.94.67L6.3 15.057V7.005h8.041zm1.635 1.638v8.051H7.935l8.042-8.051z"/>
    </svg>
  )
}

export default SelectDescribeIcon;